export const title = 'Confirma tu cuenta';
export const confirmationCodeLabel = 'Código de confirmación';
export const confirmationCodeWarning = 'Por favor ingresa tu código de confirmación';
export const confirmationSuccess = 'Tu cuenta ha sido confirmada!';
export const resendButton = 'Reenviar código';
export const resendSuccess = 'El código se ha reenviado con éxito';
export const confirmButton = 'Confirmar';
